import React from "react";
import { useSelector } from "react-redux";
import { selectCmsControlById } from "../../../redux/slices/cmsSettingsSlice";
import RecurringSummaryHeaderControl from "./RecurringSummaryHeaderControl";

/**
 * @param {object} props
 * @param {number} props.controlId
 * @returns {React.JSX.Element}
 */
const ConnectedRecurringSummaryHeaderControl = ({ controlId }) => {
    const control = useSelector((state) =>
        selectCmsControlById(state, controlId),
    );

    return <RecurringSummaryHeaderControl control={control} />;
};

export default ConnectedRecurringSummaryHeaderControl;
